export const  PreguntasEnum  = Object.freeze({
    TEXTO: 1,
    NUMERICO: 2,
    RANGO: 3,
    OPCIONES: 4,
    MEDICIONES: 5,
    MEDICIONES_SIN_ESTANDAR: 6
})